function checkForYotpoContainer() {
  if (!document.body.classList.contains('template--product')) return

  const wrapper = document.getElementById('yotpo-reviews-main-widget');

  if (!wrapper) return

  const reviewsContainer = document.getElementById('yotpo-reviews-container');
  const reviewsEmptyState = document.querySelector('.yotpo-main-layout.yotpo-main-reviews-widget .yotpo-empty-state')

  if (!reviewsContainer && !reviewsEmptyState) return

  wrapper.style.display = wrapper.contains(reviewsContainer) ? 'block' : 'none';
  observer.disconnect();
}

const observer = new MutationObserver(() => checkForYotpoContainer());

observer.observe(document.body, {
  childList: true,
  subtree: true
});

checkForYotpoContainer();
